import React, { memo } from 'react';
import CustomLink from '../CustomLink/CustomLink';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { rewriteStoryblokAssetUrl } from '../../utils/RewriteStoryblokAssetUrl/RewriteStoryblokAssetUrl.util';

export interface SocialLinkProps extends Blok {
  name: string;
  icon: StoryblokAsset;
  url: string;
}

const SocialLink: React.FC<SocialLinkProps> = ({ name, icon, url }) => {
  const iconUrl: string | null =
    icon?.filename && rewriteStoryblokAssetUrl(icon.filename);

  return (
    <li>
      <CustomLink
        url={url}
        label={name}
        target="_blank"
        className="group w-10 h-10 rounded-full bg-button/icon-bg flex items-center justify-center hover:bg-button/icon-bg-hover"
      >
        {icon?.filename && (
          <span
            className="w-full h-full bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${rewriteStoryblokAssetUrl(
                icon.filename
              )})`,
            }}
          />
        )}
      </CustomLink>
    </li>
  );
};

export default memo(SocialLink);
